import { CLEAR_UNPAID_ORDERS_MODAL, SET_UNPAID_ORDERS_MODAL } from '../../actionTypes/unpaidOrdersModal'

const initialState = {
	dateFrom: null,
	dateTo: null,
	blocking: false,
	visible: false,
}

export function unpaidOrdersModalReducer(state = initialState, action) {
	switch (action.type) {
		case SET_UNPAID_ORDERS_MODAL:
			return {
				...state,
				dateFrom: action.value.dateFrom,
				dateTo: action.value.dateTo,
				blocking: action.value.blocking,
				visible: true,
			}
		case CLEAR_UNPAID_ORDERS_MODAL:
			return {
				...initialState,
			}
		default:
			return state
	}
}
